// Styles for ChangePassword go here.
import styled from 'styled-components';

export const StyledChangePassword = styled.div``;
